// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__26hrw","colBig":"styles_colBig__2-Shy","colSmall":"styles_colSmall__3qOQT","shopifyNameWrapper":"styles_shopifyNameWrapper__smgmS"};